<section class="section-2">
  <div class="container container-special">
    <div class="row gy-5 justify-content-between">
      <div class="col-md-12 fresh-ui">
        <div class="how-works-section px-2">
          <div class="px-0">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <div class="mb-4">
                  <h2 class="sub-heading text-500 general_sans pt-4 text-center">
                    Customization Request
                  </h2>
                </div>
                <h5
                  class="sub-heading text-center mb-5"
                  style="line-height: 30px"
                >
                  Enter the Details Below and Proceed with Payment. Our Team
                  will then contact you to gather the details to start creating
                  the video.
                </h5>
              </div>
            </div>

            <!-- <div class="row justify-content-between">
                            <div class="col-lg card-section">
                                <div class="img-card">
                                    <img src="/assets/images/choose-service.svg" class="img-fluid" alt="“Edit For Me”">
                                    <div class="img-card-box">
                                        <h4>Choose Edit For Me</h4>
                                        <p>Select the desired Video /Card of your choice and Click “Edit For Me”</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-1 col-lg-auto mx-auto d-flex align-items-center">
                                <img src="/assets/images/arrow-r.webp" class="arrow d-none d-md-flex" alt="error">
                                <img src="/assets/images/arrow-b.webp" class="arrow_bottom d-flex d-md-none"
                                    alt="error">
                            </div>
                            <div class="col-lg card-section">
                                <div class="img-card">
                                    <img src="/assets/images/fill-details.svg" class="img-fluid" alt="error">
                                    <div class="img-card-box">
                                        <h4>Fill Details</h4>
                                        <p>Kindly complete the form below with your necessary details to facilitate
                                            further
                                            communication.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-1 col-lg-auto mx-auto d-flex align-items-center">
                                <img src="/assets/images/arrow-r.webp" class="arrow d-none d-md-flex" alt="error">
                                <img src="/assets/images/arrow-b.webp" class="arrow_bottom d-flex d-md-none"
                                    alt="error">
                            </div>
                            <div class="col-lg card-section ">
                                <div class="img-card">
                                    <img src="/assets/images/pay-now.svg" class="img-fluid" alt="error">
                                    <div class="img-card-box">
                                        <h4>Proceed to Payment</h4>
                                        <p>Complete Payment to Continue: Securely finalize your purchase by proceeding
                                            to the payment.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-1 col-lg-auto mx-auto d-flex justify-content-center align-items-center">
                                <img src="/assets/images/arrow-r.webp" class="arrow d-none d-md-flex" alt="error">
                                <img src="/assets/images/arrow-b.webp" class="arrow_bottom d-flex d-md-none"
                                    alt="error">
                            </div>
                            <div class="col-lg card-section card-section-last">
                                <div class="img-card">
                                    <img src="/assets/images/reach.svg" class="img-fluid" alt="error">
                                    <div class="img-card-box">
                                        <h4>We'll Reach Out to You</h4>
                                        <p>Our team will reach out to collect your images and text for personalized
                                            video invitations or Whatsapp Us on <a href="tel:+918669278777">95275 27889</a> </p>
                                    </div>
                                </div>

                            </div>
                        </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section-padding">
  <div class="container container-special">
    <div
      *ngIf="!isGenericTemplate"
      class="row align-items-center justify-content-between mb-3 d-none d-md-flex"
    >
      <div class="col-md col-auto">
        <h4>Selected Video: {{ videoDesc }}</h4>
      </div>
      <div class="col-md-auto">
        <span>Delivery Time: 1-2 Working Day.</span>
      </div>
    </div>
    <div
      *ngIf="isGenericTemplate"
      class="row align-items-center justify-content-center mb-3 d-none d-md-flex"
    >
      <div class="col-md-auto">
        <span>Delivery Time: 1-2 Working Day.</span>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <!-- <iframe width="100%" height="100%" frameborder="0"
                    class="iframe" [src]="safeVideoValue"
                    webkitallowfullscreen mozallowfullscreen allowfullscreen
                    playsinline loop loading="lazy"></iframe> -->
        <div class="card card-gray p-0 p-md-4">
          <div class="card-body">
            <div class="row justify-content-between">
              <div class="col-lg-6 card-section">
                <div class="img-card">
                  <img
                    src="/assets/images/fill-your-details.svg"
                    class="img-fluid"
                    style="max-height: 60px"
                    alt="“Edit For Me”"
                  />
                  <div class="img-card-box mt-3">
                    <h4>Fill Details</h4>
                    <p>
                      Kindly complete the form with your necessary details to
                      facilitate further communication.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 card-section m-mt-20">
                <div class="img-card">
                  <img
                    style="max-height: 60px"
                    src="/assets/images/fill-your-details.svg"
                    class="img-fluid"
                    alt="error"
                  />
                  <div class="img-card-box mt-3">
                    <h4>Sign-in or Register</h4>
                    <p>
                      You will be requested to sign-in or register if you are a
                      new user.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 card-section mt-4 m-mt-20">
                <div class="img-card">
                  <img
                    style="max-height: 60px"
                    src="/assets/images/payment-now.svg"
                    class="img-fluid"
                    alt="error"
                  />
                  <div class="img-card-box mt-3">
                    <h4>Proceed to Payment</h4>
                    <p>
                      Complete Payment to Continue: Securely finalize your
                      purchase by proceeding to the payment.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 card-section mt-4 m-mt-20 card-section-last">
                <div class="img-card">
                  <img
                    style="max-height: 60px"
                    src="/assets/images/reach-us.svg"
                    class="img-fluid"
                    alt="error"
                  />
                  <div class="img-card-box mt-3">
                    <h4>We'll Reach Out to You</h4>
                    <p>
                      Our team will reach out to collect your images and text
                      for personalized video invitations or Whatsapp Us on
                      <a href="tel:+918669278777">+9195275 27889</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <form [formGroup]="editVideoForMeForm">
          <div class="card-gray">
            <a
              class="btn btn-sm btn-outline-main w-100 mt-0 mb-3"
              (click)="editForMe()"
              >How to order video customisation</a
            >
            <div class="form-group">
              <label
                >Name
                <span
                  class="astrik-star"
                  *ngIf="f.Name.errors && f.Name.errors.required"
                  >*</span
                >:</label
              >
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="Name"
              />
              <p
                class="uk-text-danger mt-2"
                *ngIf="
                  submitted &&
                  f.Name.errors &&
                  (f.Name.errors.required || f.Name.invalid)
                "
              >
                Please enter valid name
              </p>
            </div>
            <div class="form-group">
              <label
                >Email
                <span
                  class="astrik-star"
                  *ngIf="f.Email.errors && f.Email.errors.required"
                  >*</span
                >:</label
              >
              <input
                type="email"
                class="form-control"
                id="email"
                formControlName="Email"
              />
              <p
                class="uk-text-danger mt-2"
                *ngIf="
                  submitted &&
                  f.Email.errors &&
                  (f.Email.errors.required || f.Email.invalid)
                "
              >
                Please enter valid email
              </p>
            </div>
            <div class="form-group">
              <label
                >WhatsApp
                <span
                  class="astrik-star"
                  *ngIf="f.PhoneNo.errors && f.PhoneNo.errors.required"
                  >*</span
                >:</label
              >
              <input
                type="text"
                class="form-control"
                id="phone"
                formControlName="PhoneNo"
              />
              <p
                class="uk-text-danger mt-2"
                *ngIf="
                  submitted &&
                  f.PhoneNo.errors &&
                  (f.PhoneNo.errors.required || f.PhoneNo.invalid)
                "
              >
                Please enter valid contact details
              </p>
            </div>
            <button
              type="submit"
              class="btn btn-sm btn-main w-100 mt-3"
              (click)="SaveTemplateData()"
            >
              Proceed
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
